module.exports = __webpack_public_path__ + "img/revenue.f8c53155.png";